import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "projectSelect", "categorySelect", "panel", "badge", "toggleIcon" ]
  static values = { categories: Array }

  connect() {
    this.updateCategoryState(false)
    this.updateBadgeCount()
  }

  togglePanel() {
    if (this.hasPanelTarget) {
      const isHidden = this.panelTarget.classList.contains("hidden")
      this.panelTarget.classList.toggle("hidden")
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.toggle("ti-chevron-down", !isHidden)
        this.toggleIconTarget.classList.toggle("ti-chevron-up", isHidden)
      }
    }
  }

  projectChanged() {
    this.updateCategoryState(true)
    this.updateBadgeCount()
    this.submitForm()
  }

  filterChanged() {
    this.updateBadgeCount()
    this.submitForm()
  }

  updateCategoryState(resetSelected = false) {
    if (!this.hasProjectSelectTarget || !this.hasCategorySelectTarget) return

    const selectedProjectId = this.projectSelectTarget.value
    const currentVal = resetSelected ? "" : this.categorySelectTarget.value

    const categoriesList = this.hasCategoriesValue && this.categoriesValue.length > 0
      ? this.categoriesValue
      : this.getCategoryOptionsFromDOM()

    if (!selectedProjectId) {
      this.categorySelectTarget.disabled = true
      this.categorySelectTarget.value = ""
      this.renderCategoryOptions([], "")
    } else {
      this.categorySelectTarget.disabled = false
      const filtered = categoriesList.filter(
        cat => String(cat.projectId) === String(selectedProjectId)
      )
      this.renderCategoryOptions(filtered, currentVal)
    }
  }

  getCategoryOptionsFromDOM() {
    if (!this.domCategories) {
      this.domCategories = Array.from(this.categorySelectTarget.options)
        .filter(opt => opt.value)
        .map(opt => ({
          id: opt.value,
          name: opt.textContent,
          projectId: opt.dataset.projectId
        }))
    }
    return this.domCategories
  }

  renderCategoryOptions(options, selectedVal) {
    const defaultPlaceholderText = this.categorySelectTarget.dataset.placeholder || "All Categories"
    this.categorySelectTarget.innerHTML = ""

    const defaultOpt = document.createElement("option")
    defaultOpt.value = ""
    defaultOpt.textContent = defaultPlaceholderText
    this.categorySelectTarget.appendChild(defaultOpt)

    let matchFound = false

    options.forEach(cat => {
      const optionEl = document.createElement("option")
      optionEl.value = cat.id
      optionEl.textContent = cat.name
      if (cat.projectId) optionEl.dataset.projectId = cat.projectId
      if (String(cat.id) === String(selectedVal)) {
        optionEl.selected = true
        matchFound = true
      }
      this.categorySelectTarget.appendChild(optionEl)
    })

    if (!matchFound) {
      this.categorySelectTarget.value = ""
    }
  }

  updateBadgeCount() {
    if (!this.hasBadgeTarget) return

    let count = 0
    const filterNames = ["project_id", "category_id", "priority", "assignee", "due_date_filter"]

    filterNames.forEach(name => {
      const el = this.element.querySelector(`select[name="${name}"]`)
      if (el && el.value && el.value.trim() !== "") {
        count++
      }
    })

    if (count > 0) {
      this.badgeTarget.textContent = count
      this.badgeTarget.classList.remove("hidden")
      this.badgeTarget.classList.add("inline-flex")
    } else {
      this.badgeTarget.textContent = ""
      this.badgeTarget.classList.add("hidden")
      this.badgeTarget.classList.remove("inline-flex")
    }
  }

  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
